import { render, staticRenderFns } from "./OTSU.vue?vue&type=template&id=13efa03f"
import script from "./OTSU.vue?vue&type=script&lang=js"
export * from "./OTSU.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports